import Vue from 'vue';

export default (context, formData) => {
    return Vue.$http.post('/files', formData);
};



// WEBPACK FOOTER //
// ./src/app/services/file/uploadImage.js